export default class LocalStorage<T> {
	private readonly keyName: string;
	private readonly ignoreValues: string[] | undefined;
	private readonly defaultValues?: T;

	constructor(name: string, ignoreValues?: string[], defaultValues?: T) {
		this.keyName = 'LP-' + name;
		this.ignoreValues = ignoreValues;
		this.defaultValues = defaultValues;
	}

	public get value(): T | undefined | null {
		try {
			const ret = window.localStorage.getItem(this.keyName);
			if (ret ) {
				const values = JSON.parse(ret) as T;
				if (values )
					return this.defaultValues ? { ...this.defaultValues, ...values } : values;
			}
			return this.defaultValues || null;
		}
		catch (e) {
			window.localStorage.removeItem(this.keyName);
		}
		return this.defaultValues || null;
	}

	public set value(a: T | undefined | null) {
		if (a === undefined || a === null)
			window.localStorage.removeItem(this.keyName);
		else {
			try {
				let out = JSON.stringify(a);
				if (this.ignoreValues && this.ignoreValues.length) {
					const stateFilter = JSON.parse(out); // deep clone
					this.ignoreValues // states which we don't want to persist.
						.forEach(item => delete stateFilter[item]);
					out = JSON.stringify(stateFilter);
				}
				window.localStorage.setItem(this.keyName, out);
			}
			catch (e) { }
		}
	}

	//public getOrDefault = (def: T): T => {
	//	const val = this.value;
	//	return val === undefined || val === null ? def : val;
	//}

	public reset = () =>
		window.localStorage.removeItem(this.keyName);
}